export default class Dialog {
    constructor(buttonOrUrl, options) {
        this.button = false;
        this.ajaxUrl = false;
        if (typeof buttonOrUrl === 'string') {
            this.ajaxUrl = buttonOrUrl;
        } else {
            this.button = buttonOrUrl;
        }
        this.options = {
            targetAttr: 'dialog-target',
            closeButtonClass: '.js-dialog-close',
            contentClass: '.js-dialog-content',
            activeClass: 'is-active',
            dialogClass: '.pfx-dialog',
            urlAttr: 'dialog-url',
            targetId: 'j-dialog-ajax',
            postData: null,
            onBeforeShow: null,
            onShow: null,
            onBeforeHide: null,
            onHide: null,
            onError: null,
            ...options,
        };
        this.isActive = false;
    }

    init() {
        if (this.ajaxUrl) {
            this.initAjaxUrl();
        }
        if (this.button) {
            this.initButton();
        }
    }

    initButton() {
        if (this.button.classList.contains('plugin-dialog-initialized')) return;
        const target = this.button.getAttribute(this.options.targetAttr);

        if (target) {
            this.target = document.querySelector(target);
            this.button.addEventListener('click', (event) => this.handleClick(event));

            this.bindEvents();
        } else {
            this.ajaxUrl = this.button.getAttribute(this.options.urlAttr);
            if (this.ajaxUrl) {
                this.button.addEventListener('click', (event) => {
                    event.preventDefault();
                    this.initAjaxUrl();
                });
            }
        }
        this.button.classList.add('plugin-dialog-initialized');
    }

    initAjaxUrl() {
        if (this.options.onBeforeShow) this.options.onBeforeShow();

        fetch(this.ajaxUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(this.options.postData),
        })
            .then(response => response.text())  // Get response as text
            .then(data => {
                const div = document.getElementById(this.options.targetId);
                let outerDiv = div;
                if (!div) {
                    const newDiv = document.createElement('div');
                    newDiv.id = this.options.targetId;
                    newDiv.innerHTML = data;
                    document.body.appendChild(newDiv);
                    this.target = newDiv.querySelector(this.options.dialogClass);
                    outerDiv = newDiv;
                } else {
                    div.innerHTML = data; // Update existing div if needed
                    this.target = div.querySelector(this.options.dialogClass);
                }
                // Execute any scripts inside the inserted data
                outerDiv.querySelectorAll("script").forEach((script) => {
                    const newScript = document.createElement("script");
                    if (script.src) {
                        newScript.src = script.src; // External script
                        newScript.async = false; // Ensures execution order
                    } else {
                        newScript.textContent = script.textContent; // Inline script
                    }
                    outerDiv.appendChild(newScript);
                    script.remove();
                });

                this.open();
                this.bindEvents();

            })
            .catch(error => {
                console.error("Error loading content:", error);

                // Run onError hook if provided
                if (this.options.onError) this.options.onError(error);
            })
            .finally(() => {
                if (this.options.onShow) this.options.onShow();
            });
    }

    handleClick(event) {
        event.preventDefault();

        if (this.isActive) {
            this.close();
        }

        if (!this.isActive) {
            this.open();
        }
    }

    bindEvents() {
        this.content = this.target.querySelector(this.options.contentClass);
        if (this.content) {
            this.target.addEventListener('click', (event) => this.clickInside(event));
        }

        const closeButtons = Array.from(this.target.querySelectorAll(this.options.closeButtonClass));
        closeButtons.forEach((button) => {
            button.addEventListener('click', () => this.close());
        });

        document.addEventListener('keyup', (event) => this.onClickKeyboard(event));
    }

    /**
     * Document Click Func
     * @param {HTMLElement} event event
     */
    clickInside(event) {
        const clickInside = this.content.contains(event.target);

        if (this.isActive && !clickInside) {
            this.close();
        }
    }

    /**
     * Keyboard Key
     * @param {HTMLElement} event event
     */
    onClickKeyboard(event) {
        if (event.keyCode === 27) {
            this.close();
        }
    }

    open() {
        this.target.classList.add(this.options.activeClass);
        this.isActive = true;
    }

    close() {
        this.target.classList.remove(this.options.activeClass);
        this.isActive = false;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const buttons = Array.from(document.querySelectorAll('.js-dialog'));
    buttons.forEach((button) => {
        const dialog = new Dialog(button);
        dialog.init();
    });
});
